import React from 'react'
import './Login.css'
// import Bar from '../../Component/Bar/Bar'
import Cover from '../../Component/Cover/Cover'

function Login() {
    return (
        <div>
            <div className="right">
                
            </div>
            <div className="left">
                <Cover />
            </div>
        </div>
    )
}

export default Login